import { enumLocalStorageKeys } from '@enum/enumLocalStorageKeys';
import { VERIFICATION_CODE_LIFE_MINUTES } from '@constants/verification-code';
import { DateHelper } from '@helpers/date.helper';
import dayjs from '../services/dayjs.service';

export class VerificationCodeHelper {
  public static isVerificationCodeExpired(phoneNumber: string): boolean {
    const lastSentVerificationCodeDate: string = localStorage.getItem(enumLocalStorageKeys.LAST_SENT_VERIFICATION_CODE_DATE);
    const lastSentVerificationCodePhone: string = localStorage.getItem(enumLocalStorageKeys.LAST_SENT_VERIFICATION_CODE_PHONE);
    const now: dayjs.Dayjs = dayjs(DateHelper.now);
    return (
      !lastSentVerificationCodePhone ||
      lastSentVerificationCodePhone !== phoneNumber ||
      !lastSentVerificationCodeDate ||
      dayjs.duration(now.diff(dayjs(lastSentVerificationCodeDate))).asMinutes() >= VERIFICATION_CODE_LIFE_MINUTES
    );
  }

  public static setVerificationCode(phoneNumber: string): void {
    localStorage.setItem(enumLocalStorageKeys.LAST_SENT_VERIFICATION_CODE_DATE, DateHelper.now);
    localStorage.setItem(enumLocalStorageKeys.LAST_SENT_VERIFICATION_CODE_PHONE, phoneNumber);
  }
}
